<template lang="pug">
    form-group-layout.tag-box-field(:label='label' v-bind='$attrs')
        template(v-slot='{invalid, errors, touch}')
            label(v-if='label') {{ label }}
            tag-box-control(v-model='model' :whitelist='whitelist' :nameColumn='nameColumn' :invalid='invalid'
                    :placeholder='placeholder' :validateNew='validateNew' :disabled='disabled'
                    @blur='touch' @change='change($event); touch();' @create='create')
            inline-error-control(:errors='errors' :relative='true')
</template>

<script>
export default {
    name: 'tag-box-field',
    props: {
        value: Array,
        label: String,
        whitelist: Array,
        nameColumn: String,
        placeholder: String,
        validateNew: Function,
        disabled: Boolean,
    },
    computed:{
        model:{
            get(){
                return this.value
            },
            set(val){
                this.$emit('input', val)
            },
        },
    },
    methods: {
        change(model) {
            this.model = model
        },
        create(value) {
            this.$emit('create', value)
        },
    },
}
</script>
